export default __webpack_public_path__ + "static/media/contact.005ac0b7.png";